/**
 * @module app.core
 */

import { apiCall } from 'app/shared/lib/essette-api';
import { autoinject } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { I18N } from 'aurelia-i18n';
import { MemberService } from 'app/cd/services/member-service';
import { Toaster } from 'app/shared/lib/toaster';
import * as CD from 'app/cd/models/essette-api';
@autoinject()
export class SaveEligibilityProduct extends ComponentBase implements IForm {

    ////****************** Fields and Properties ************************************////

    @bindable
    protected memberId: string | null = null;
    @bindable
    protected memberPlanId: string | null = null;
    public memberEligibility: CD.MemberEligibility | null = null;
    public eligibilityProduct: CD.MemberEligibility | null = null;

    @bindable
    protected lineOfBusiness: string | null = null;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: MemberService,
        private readonly toaster: Toaster,
        private readonly i18n: I18N,
        ...rest: any[]) {
        super(...rest);
    }

    protected bind(): void {
        this.reset();
    }

    ////****************** Events ***************************************************////

    ////****************** Functions ************************************************////
    protected clear(): void {
        this.memberEligibility = {};
    }

    protected buildProduct(): CD.MemberEligibility {
        const saveProduct: CD.MemberEligibility = {
            id: this.memberEligibility?.id,
            product: {
                id: this.memberEligibility?.product?.id,
            },
            dateRange: this.memberEligibility?.dateRange,
            receivedDate: this.memberEligibility?.receivedDate,
            shareOfCostAmount: this.memberEligibility?.shareOfCostAmount,
            employer: this.memberEligibility?.employer,
            groupNumber: this.memberEligibility?.groupNumber,
            member: {
                id: this.memberId,
                plan: { id: this.memberPlanId }
            }
        };

        return saveProduct;
    }

    public loadProduct(planId: string, lobId: string): void {
        if(planId && lobId) {
            this.eligibilityProduct = {
                product: { healthPlan: { id: planId }, lineOfBusiness: { id: lobId } }
            };
        }
    }

    ////****************** IForm ****************************************************////
    public hasChanges(): boolean {
        throw new Error('Method not implemented.');
    }

    public async submit(): Promise<boolean> {
        const isSuccess = await this.saveProduct();
        return isSuccess;
    }

    public reset(): void {
        this.clear();
    }

    ////****************** Service Calls ********************************************////

    @apiCall
    protected async saveProduct(): Promise<boolean> {
        const insertProduct: CD.MemberPlan = this.buildProduct();

        let isSuccessful = false;
        let errorMessage: string = "";

        try {
            this.state.beginSave();
            if(insertProduct) {
                const response = await this.service.saveEligibility(insertProduct);
                isSuccessful = response.isSuccessful;
            } else {
                errorMessage = this.i18n.tr('ui:messages.events.saveFailed', { what: this.i18n.tr('cd:member.eligibility.product.$long') });
            }
        }
        catch(error) {
            if(error.description) { errorMessage = error.description; }
            throw error;
        }
        finally {
            if(!isSuccessful) {
                const exception = (this.toaster.toast())
                    .title('Error')
                    .class('ess-toast-error')
                    .icon('ui:icons.error')
                    .message(errorMessage)
                exception.show();
            }
            else {
                if(this.memberEligibility?.id) {
                    this.toaster.standard.updated('cd:member.eligibility.product.$long', isSuccessful);
                } else {
                    this.toaster.standard.created('cd:member.eligibility.product.$long', isSuccessful);
                }
            }
            this.state.endSave();
            return isSuccessful;
        }
    }

}
